<!-- <h1 class="h1 secondary-text"><p class="texto">{{'RESULTADOS.COMINGSOON' | translate}}</p></h1> -->
<div fxLayout="column" fxFlex="100" fxLayoutAlign="center center">
  <ng-container *ngIf="cargando">
    <div fxLayout="row wrap" fxLayoutAlign="center center" [@animateStagger]="{value:'50'}">
      <div fxFlex="100" fxLayout="column" fxLayoutAlign="center center"  [@animate]="{value:'*',params:{delay:'250ms', y:'25px'}}">
          <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
          <h2>{{'RESULTADOS.CARGANDO' | translate}}</h2>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="!cargando">
    <form action="{{urlTableauCovid}}" method="post" id="RecDatos" target="frameTableau">
      <input name="cvk" type="hidden" value="{{cvk}}">
      <input name="lang" type="hidden" value="{{langCode}}">
      <input name="brk" type="hidden" value="{{brk}}">
    </form>

    <iframe name="frameTableau"></iframe>
  </ng-container>
</div>
